import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb, CustomSnackBar, SimpleCard } from "app/components";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { endPointName } from "apis/apiList";
import { CallAPI, CallAPISasUploadVideo, CallAPIUploadPic } from "apis/callAPI";
import moment from "moment/moment";
import MuiAlert from "@mui/material/Alert";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate } from "react-router-dom";
import Loading from "../MatxLoading";
import { catchError } from "app/firebase/Crashlytics";
import DocumentTitle from "react-document-title";
import { NumberValidate } from "utils/utilities";
import { yrfGender } from "app/constant";
import useAuth from "app/hooks/useAuth";
import ServerErrorModal from "../ServerErrorModal";
import { sasToken } from "authConfig";
import db from "app/db/database";
import State from "../../constant/CityStateCountry.json";
import Swal from "sweetalert2";
import "../../styles/App.css";

const TextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: 16,
}));

const CreateUpdatePost = ({ use, postId, onSubmit, validTillExp }) => {
  const { logout, user } = useAuth();
  const userFromSession = JSON.parse(sessionStorage.getItem("userJSON"));
  const accessToken = window.localStorage.getItem("accessToken");
  const fileUploadRef = useRef();
  const videoUploadRef = useRef();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [fromAge, setAgeFrom] = useState("");
  const [toAge, setToAge] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [PostId, setPostId] = useState(0);
  const [publishOn, setPublishOn] = useState(null);
  const [validTill, setvalidTill] = useState(null);
  const [cities, setCities] = useState([]);
  const [States, setStates] = useState([]);
  const [userGenderValue, setUserGenderValue] = useState();
  const [UserLanguageValue, setUserLanguageValue] = useState([]);
  const [UserCityValue, setUserCityValue] = useState([]);
  const [userStateValue, setUserStateValue] = useState([]);
  const [languagesList, setLanguagesList] = useState([]);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [allCities, setAllCities] = useState([]);
  const [allStatesCity, setAllStatesCity] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [APILoading, setAPILoading] = useState(false);
  const [onApiLoading, setOnApiLoading] = useState(false);
  const [projectSelected, setProjectSelected] = useState(null);
  const [projectList, setProjectList] = useState([]);
  const [charSelected, setCharSelected] = useState(null);
  const [characterData, setCharacterData] = useState([]);
  const [radioValue, setRadioValue] = useState(1);
  const [uploadFile, setUploadFile] = useState("");
  const [fileFlag, setFileFlag] = useState(false);
  const [uploadVideoFile, setUploadVideoFile] = useState("");
  const [videoFileFlag, setVideoFileFlag] = useState(false);
  const [uploadSelectedVideoFile, setUploadSelectedVideoFile] = useState([]);
  const [openValidTill, setOpenValidTill] = useState(false);
  const [openPublishOn, setOpenPublishOn] = useState(false);
  const [fileURL, setFileURL] = useState([]);
  const [fileVideoUrl, setFileVideoURL] = useState([]);
  const [uploadSelectedFile, setUploadSelectedFile] = useState([]);
  const [errorPopUp, setErrorPopUp] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isOnline, setOnline] = useState(true);
  const [IsFileError, setIsFileError] = useState(false);
  const [allCountries, setAllCountries] = useState([]);
  const [userCountryValue, setUserCountryValue] = useState([]);
  const controller = new AbortController();
  const signal = controller.signal;
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const gender = [
    {
      label: "Both",
      value: 2,
    },
    {
      label: "Female",
      value: 1,
    },
    {
      label: "Male",
      value: 0,
    },
  ];

  useEffect(() => {
    setOnline(navigator.onLine);
  }, []);

  window.addEventListener("online", () => {
    setOnline(true);
  });

  window.addEventListener("offline", () => {
    setOnline(false);
    controller.abort();
  });

  const getStates = async () => {
    try {
      if ((await db.state.count()) === 0) {
        let responseState = State;
        if (responseState) {
          setAllStatesCity(responseState.cityStateModels);
          getPostDetails(responseState.cityStateModels);
          db.state
            .bulkAdd(responseState.cityStateModels)
            .then((res) => {
              console.log("Master data (states) stored successfully");
            })
            .catch((error) => {
              console.error("Error storing master data:", error);
            });
        } else {
          setErrorMsg("Server Error");
          setErrorPopUp(true);
        }
      } else {
        const states = await db.state.toArray();
        setAllStatesCity(states);
        getPostDetails(states);
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_1");
    }
  };

  const getCities = async () => {
    try {
      const cities = await db.city.toArray();
      let cityData = cities.map((el) => ({ label: el.city, value: el.cityId }));
      setAllCities(cityData);
      return cities;
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_2");
    }
  };

  const getCountries = async () => {
    try {
      if ((await db.countries.count()) === 0) {
        let response = await CallAPI(endPointName.Country, "get");
        if (response) {
          let countryData = response.map((el) => ({
            label: el.country,
            value: el.countryId,
          }));
          setAllCountries(countryData);
          db.countries
            .bulkAdd(response)
            .then((res) => {
              console.log("Master data (countries) stored successfully");
            })
            .catch((error) => {
              console.error("Error storing master data:", error);
            });
        } else {
          setErrorMsg("Server Error");
          setErrorPopUp(true);
        }
      } else {
        const countries = await db.countries.toArray();
        let countryData = countries.map((el) => ({
          label: el.country,
          value: el.countryId,
        }));
        setAllCountries(countryData);
      }
    } catch (error) {
      catchError(error, "Error fetching countries Create Update Post:");
    }
  };

  const getLanguages = async () => {
    try {
      let response = await CallAPI(endPointName.Language, "get");
      if (response !== "error") {
        setLanguagesList(response);
      } else {
        setErrorMsg("Server Error");
        setErrorPopUp(true);
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_3");
    }
  };

  const onSubmitPost = async (param, param1) => {
    try {
      if (isOnline) {
        const accessTokenCheck = window.localStorage.getItem("accessToken");
        if (accessTokenCheck !== null) {
          if (parseInt(fromAge) <= parseInt(toAge)) {
            setOnApiLoading(true);
            let orgIdFromSession = JSON.parse(
              sessionStorage.getItem("userJSON"),
            );

            if (uploadSelectedFile.length === 0 && radioValue === "2") {
              setIsFileError(true);
            } else {
              setIsFileError(false);
            }

            let fileToUpload = [];
            if (fileFlag == true) {
              for (let i = 0; i < uploadSelectedFile.length; i++) {
                let source = new FormData();
                setAPILoading(true);
                source.append("name", uploadSelectedFile[i].name);
                source.append("file", uploadSelectedFile[i]);
                let fileUrl = await CallAPIUploadPic(
                  endPointName.FileUpload + "4",
                  source,
                );
                fileToUpload.push(fileUrl.uploadDocURL);
              }
            }

            let tempVideo = [];
            if (videoFileFlag === true) {
              for (let i = 0; i < uploadSelectedVideoFile.length; i++) {
                let fileUrl = await CallAPISasUploadVideo(
                  sasToken,
                  uploadSelectedVideoFile[i],
                  signal,
                );
                let dataUrl = fileUrl.url.split(`${sasToken}`);
                tempVideo.push(dataUrl[0]);
              }
            }

            /** End code for file upload */
            const payload = {
              Param: param,
              PostId: PostId,
              Title: title,
              AgeFrom: fromAge,
              AgeTo: toAge,
              CharacterId: charSelected.characterId,
              filesAttachment: fileFlag == true ? fileToUpload : [],
              videosAttachment: videoFileFlag == true ? tempVideo : [],
              AuditionType: radioValue,
              Gender: userGenderValue
                ? userGenderValue.value
                : userFromSession.organizationId === 4
                  ? "3"
                  : "2",
              States:
                userStateValue.length == 0
                  ? ["0"]
                  : userStateValue.map((el) => el.value),
              Cities:
                UserCityValue.length == 0
                  ? ["0"]
                  : UserCityValue.map((el) => el.value),
              Countries:
                userCountryValue.length == 0
                  ? ["0"]
                  : userCountryValue.map((el) => el.value),
              Description: description,
              PublishOn: moment(publishOn).format("YYYY-MM-DD"),
              ValidTill: moment(validTill).format("YYYY-MM-DD"),
              OrganizationId: orgIdFromSession.organizationId,
              Languages:
                UserLanguageValue.length == 0
                  ? ["0"]
                  : UserLanguageValue.map((el) => el.languageId),
              createdBy: userFromSession.adminUserId,
              isActive: 1,
            };
            const AddEditPostResponse = await CallAPI(
              endPointName.AddEditPostV2,
              "post",
              payload,
            );
            if (AddEditPostResponse.statusCode == 200) {
              let payload = {
                Param: param,
                Title: title,
                AgeFrom: fromAge,
                AgeTo: toAge,
                Gender: userGenderValue
                  ? userGenderValue.value
                  : userFromSession.organizationId === 4
                    ? "3"
                    : "2",
                Description: description,
                OrganizationId: orgIdFromSession.organizationId,
                States:
                  userStateValue.length == 0
                    ? []
                    : userStateValue.map((el) => el.value),
                Cities:
                  UserCityValue.length == 0
                    ? []
                    : UserCityValue.map((el) => el.value),
              };
              const notificationResponse = await CallAPI(
                endPointName.SendAuditionCreationNotification,
                "post",
                payload,
              );
              setOnApiLoading(false);
              if (use == "create") {
                Swal.fire({
                  title: "Audition Created successfully",
                  text: "",
                  icon: "success",
                  confirmButtonText: "Home",
                  confirmButtonColor: "#B93B3E",
                  cancelButtonText: "List",
                  showCancelButton: true,
                }).then((val) => {
                  if (val.isConfirmed) {
                    navigate("/dashboard");
                  } else {
                    navigate("/post/ListPost");
                  }
                });
              } else {
                setAPILoading(true);
              }
              if (use == "create") {
                setOnApiLoading(false);
                setTitle("");
                setDescription("");
                setAgeFrom("");
                setToAge("");
                setUserStateValue([]);
                setUserCityValue([]);
                setUserGenderValue();
                setUserLanguageValue([]);
                setPublishOn(null);
                setProjectSelected(null);
                setCharSelected(null);
                setvalidTill(null);
                setAPILoading(false);
              } else if (use == "update") {
                setSnackBarMessage("Audition updated successfully");
                setOnApiLoading(false);
                setSnackOpen(true);
                onSubmit();
              }
            } else if (AddEditPostResponse.statusCode === 201) {
              setOnApiLoading(false);
              setErrorMsg("Already Exist Audition");
              setErrorPopUp(true);
            } else {
              setOnApiLoading(false);
              setSnackOpen(true);
              setSnackBarMessage("Server Error");
            }
          } else {
            setSnackBarMessage("Enter Valid Age");
            setSnackOpen(true);
          }
        } else {
          logout();
        }
      } else {
        setErrorMsg("No Internet");
        setErrorPopUp(true);
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_5");
    }
  };

  const handleCloseSnackBar = (_, reason) => {
    try {
      if (reason === "clickaway") {
        return;
      }
      setSnackOpen(false);
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_6");
    }
  };

  const getPostDetails = async (allStatesCity) => {
    try {
      setAPILoading(true);
      const dataProj = await getProjectDetails();
      const payload = {
        postId: postId,
      };
      let responsePostDetails = await CallAPI(
        endPointName.getPostDetails,
        "POST",
        payload,
      );
      if (responsePostDetails !== "error") {
        setPostId(responsePostDetails.postId);
        setTitle(responsePostDetails.title);
        setAgeFrom(
          responsePostDetails.ageFrom === 0 ? "" : responsePostDetails.ageFrom,
        );
        setToAge(
          responsePostDetails.ageTo === 0 ? "" : responsePostDetails.ageTo,
        );
        if (responsePostDetails.filesAttachment.length > 0) {
          setUploadSelectedFile(responsePostDetails.filesAttachment);
        }
        if (responsePostDetails.videosAttachment.length > 0) {
          setUploadSelectedVideoFile(responsePostDetails.videosAttachment);
        }
        setFileURL(responsePostDetails.filesAttachment);
        setFileVideoURL(responsePostDetails.videosAttachment);
        setUserLanguageValue(responsePostDetails.language);
        setRadioValue(responsePostDetails.auditionType);
        setPublishOn(responsePostDetails.publishOn);
        if (validTillExp) {
          setvalidTill(null);
        } else {
          setvalidTill(responsePostDetails.validTill);
        }
        setDescription(responsePostDetails.description);
        let tempProject = dataProj.filter(
          (el) => el.projectId == responsePostDetails.projectId,
        );
        if (use == "update" && tempProject) {
          if (
            moment(new Date()).format("YYYY-MM-DD") <
            moment(tempProject[0].endDate).format("YYYY-MM-DD")
          ) {
            setEndDate(tempProject[0].endDate);
          }
        }
        setCharacterData(tempProject[0].characterData);
        setProjectSelected(tempProject[0]);
        let tempCharacter = tempProject[0].characterData.filter(
          (el) => el.characterId == responsePostDetails.characterId,
        );
        setCharSelected(tempCharacter[0]);
        setUserCountryValue(
          responsePostDetails.countries.map((el) => ({
            label: el.country,
            value: el.countryId,
          })),
        );

        const filteredStates1 = [];
        const filteredstate = responsePostDetails.countries.map((el) => {
          let states = allStatesCity.filter(
            (element) => element.countryId == el.countryId,
          );

          filteredStates1.push(...states);
        });
        const uniqueStates = [];
        filteredStates1.forEach((item) => {
          if (
            !uniqueStates.some(
              (stateItem) => stateItem.stateId === item.stateId,
            )
          ) {
            uniqueStates.push({ state: item.state, stateId: item.stateId });
          }
        });

        let states = uniqueStates.map((el) => ({
          label: el.state,
          value: el.stateId,
        }));
        setStates(states);

        setUserStateValue(
          responsePostDetails.state.map((el) => ({
            label: el.state,
            value: el.stateId,
          })),
        );
        let getAllCities = await getCities();
        let cityData = responsePostDetails.city.filter((element) => {
          let filterAllCities = getAllCities.filter((el) => {
            setAPILoading(true);
            if (element.cityId == el.cityId) {
              element.stateId = el.stateId;
            }
          });
        });
        setUserCityValue(
          responsePostDetails.city.map((el) => ({
            label: el.city,
            value: el.cityId,
            stateId: el.stateId,
          })),
        );
        if (userFromSession.organizationId === 4) {
          let genderVal = yrfGender.filter(
            (el) => el.value == responsePostDetails.gender,
          );
          setUserGenderValue(genderVal[0]);
        } else {
          let genderVal = gender.filter(
            (el) => el.value == responsePostDetails.gender,
          );
          setUserGenderValue(genderVal[0]);
        }
        if (use == "update" && responsePostDetails.state.length == 0) {
          getCities();
        } else {
          getCities();
        }
        const filteredCities1 = [];
        const filteredCities = responsePostDetails.state.map((el) => {
          let cities = allStatesCity.filter(
            (element) => element.stateId == el.stateId,
          );
          filteredCities1.push(cities);
        });
        if (filteredCities.length > 0) {
          let cities = filteredCities1[0].map((el) => ({
            label: el.city,
            value: el.cityId,
          }));
          setCities(cities);
        }
      } else {
        setErrorMsg("Server Error");
        setErrorPopUp(true);
      }
      setAPILoading(false);
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_7");
    }
  };
  const getProjectDetails = async () => {
    try {
      let userFromSession = JSON.parse(sessionStorage.getItem("userJSON"));
      const payload = {
        OrganizationId: userFromSession.organizationId,
        RoleId: userFromSession.roleId,
        CreatedBy:
          userFromSession.roleId === 2 || userFromSession.roleId === 3
            ? userFromSession.createdBy
            : 0,
        AdminUserId:
          userFromSession.roleId === 2 || userFromSession.roleId === 3
            ? userFromSession.adminUserId
            : 0,
      };
      let responseProjectDetails = await CallAPI(
        endPointName.AllProjectData,
        "POST",
        payload,
      );
      if (responseProjectDetails) {
        setProjectList(responseProjectDetails);
      } else {
        setErrorMsg("Server Error");
        setErrorPopUp(true);
      }
      return responseProjectDetails;
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_8");
    }
  };

  useEffect(() => {
    if (accessToken !== null) {
      if (isOnline) {
        {
          use == "update" && setAPILoading(true);
        }
        getProjectDetails();
        getCountries();
        getStates();
        {
          use == "insert" && getCities();
        }
        getLanguages();
      } else {
        setErrorMsg("No Internet");
        setErrorPopUp(true);
      }
    } else {
      logout();
    }
  }, [accessToken]);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleChange = (event) => {
    try {
      setRadioValue(event.target.value);
      setUploadFile("");
      setUploadVideoFile("");
      setUploadSelectedFile([]);
      setUploadSelectedVideoFile([]);
      setFileFlag(false);
      setVideoFileFlag(false);
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_9");
    }
  };

  const onChangeProject = (el) => {
    try {
      if (el == null) {
        setCharSelected(null);
        setProjectSelected(null);
        setEndDate("");
      } else {
        if (
          moment(new Date()).format("YYYY-MM-DD") >
          moment(el.endDate).format("YYYY-MM-DD")
        ) {
          Swal.fire({
            title: "",
            text: `Project selection can not be done.\nSince this project has expired.`,
            icon: "warning",
            confirmButtonText: "Ok",
            confirmButtonColor: "#B93B3E",
            customClass: {
              container: "swal2-container-zIndex",
            },
          }).then((val) => {});
        } else {
          setProjectSelected(el);
          setEndDate(el.endDate);
          setvalidTill(null);
          setCharSelected(null);
          setCharacterData(el !== null ? el.characterData : []);
        }
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_10");
    }
  };

  const onChangeCharacter = (el) => {
    try {
      if (el !== null) {
        if (el.userId && el.userName) {
          Swal.fire({
            title: "",
            text: `Actor selection is not possible.\nSince an actor has already been selected for this role.`,
            icon: "warning",
            confirmButtonText: "Ok",
            confirmButtonColor: "#B93B3E",
            customClass: {
              container: "swal2-container-zIndex",
            },
          }).then((val) => {});
        } else {
          setCharSelected(el);
        }
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_11");
    }
  };

  const fileChangedHandler = (event) => {
    try {
      if (event.target.files.length > 0) {
        let fileToUpload = [];
        for (let i = 0; i < event.target.files.length; i++) {
          let fileSize = event.target.files[i].size;
          if (fileSize > 5000000) {
            setUploadFile("");
            setUploadSelectedFile([]);
            setSnackBarMessage("Please upload a file smaller than 5 MB");
            setSnackOpen(true);
          } else {
            if (event.target.value.length !== 0) {
              setUploadFile(event.target.value);
              fileToUpload.push(event.target.files[i]);
              setFileFlag(true);
            } else {
              setUploadFile(event.target.value);
            }
          }
        }
        setUploadSelectedFile(fileToUpload);
      } else {
        setUploadFile("");
        setUploadSelectedFile("");
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_12");
    }
  };

  const fileChangedHandlerVideo = (event) => {
    try {
      if (event.target.files.length > 0) {
        let fileToUpload = [];
        for (let i = 0; i < event.target.files.length; i++) {
          if (event.target.value.length !== 0) {
            setUploadVideoFile(event.target.value);
            fileToUpload.push(event.target.files[i]);
            setVideoFileFlag(true);
          } else {
            setUploadVideoFile(event.target.value);
          }
        }
        setUploadSelectedVideoFile(fileToUpload);
      } else {
        setUploadVideoFile("");
        setUploadSelectedVideoFile("");
      }
    } catch (error) {
      setAPILoading(false);
      catchError(error, "CreateUpdatePost_12");
    }
  };

  const handleTextFieldClick = (type) => {
    try {
      if (type === "publishOn") {
        setOpenPublishOn(true);
      } else {
        setOpenValidTill(true);
      }
    } catch (error) {
      catchError(error, "CreateUpdatePost_13");
    }
  };

  const handleServerError = () => {
    try {
      setErrorPopUp(false);
      setErrorMsg("");
    } catch (error) {
      catchError(error, "CreateUpdatePost_14");
    }
  };

  const onChangeCountry = (el) => {
    try {
      if (el.length === 0) {
        setUserCountryValue(null);
      } else {
        setUserCountryValue(el);
        let stateFilter = allStatesCity.filter(
          (elm) =>
            elm.countryId == el[el.length - 1].value &&
            elm.isStateActive == true,
        );
        let uniqueList = stateFilter.filter(
          (elem, i, a) =>
            a.findIndex((item) => item.stateId === elem.stateId) === i,
        );
        let mapState = uniqueList.map((el) => ({
          label: el.state,
          value: el.stateId,
          countryId: el.countryId,
        }));
        if (el.length == 1) {
          setStates(mapState);
        } else {
          const temp2 = States.concat(mapState);
          setStates(temp2);
        }
      }
    } catch (error) {
      catchError(error, "CreateUpdatePost_15");
    }
  };
  const onClickSubmitPost = async (use) => {
    try {
      Swal.fire({
        title: `Are you sure you want to ${use === "Insert" ? "submit" : "update"}`,
        text: "",
        icon: "question",
        confirmButtonText: "Yes",
        confirmButtonColor: "#B93B3E",
        cancelButtonText: "No",
        showCloseButton: true,
        showCancelButton: true,
        customClass: {
          container: "swal2-container-zIndex",
        },
      }).then((val) => {
        if (val.isConfirmed) {
          onSubmitPost(use);
        }
      });
    } catch (error) {
      catchError(error, "CreateUpdatePost_15");
    }
  };

  return (
    <DocumentTitle title={"Create New Audition"}>
      <div style={{ margin: use == "create" ? 30 : 0 }}>
        <Stack spacing={2}>
          {use == "create" && (
            <Box className="breadcrumb">
              <Breadcrumb
                routeSegments={[
                  { name: "Create New Audition", namePage: "Auditions" },
                ]}
              />
            </Box>
          )}
          {use == "create" ? (
            <>
              <SimpleCard>
                <ValidatorForm
                  onSubmit={() =>
                    onClickSubmitPost(use == "create" ? "Insert" : "Update")
                  }
                  onError={() => null}
                >
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
                  >
                    <Grid item xs={4}>
                      <Autocomplete
                        options={projectList}
                        size="medium"
                        getOptionLabel={(option) => option.projectName}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography>{option.projectName}</Typography>{" "}
                            {moment(new Date()).format("YYYY-MM-DD") >
                              moment(option.endDate).format("YYYY-MM-DD") && (
                              <Typography
                                style={{
                                  color: "red",
                                  fontSize: 10,
                                  opacity: 0.8,
                                  fontStyle: "italic",
                                }}
                              >
                                Expired:{" "}
                                {moment(option.endDate).format("DD-MM-YYYY")}
                              </Typography>
                            )}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 1 }}
                            variant="outlined"
                            label="Select Project*"
                            value={projectSelected}
                            fullWidth
                            validators={["required"]}
                            errorMessages={["Project is required"]}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={projectSelected}
                        onChange={(_, newValue) => {
                          onChangeProject(newValue);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ marginTop: isNonMobile == false && -20 }}
                    >
                      <Autocomplete
                        options={characterData}
                        size="medium"
                        getOptionLabel={(option) => option.characterName}
                        renderOption={(props, option) => (
                          <Box component="li" {...props}>
                            <Typography
                              style={{
                                color:
                                  option.userName !== "" ? "green" : "black",
                              }}
                            >
                              {option.characterName}
                            </Typography>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 2 }}
                            variant="outlined"
                            label="Select Character*"
                            value={charSelected}
                            fullWidth
                            autoComplete="off"
                            validators={["required"]}
                            errorMessages={["Character is required"]}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={charSelected}
                        onChange={(_, newValue) => {
                          onChangeCharacter(newValue);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{
                        marginTop: isNonMobile == false && -30,
                        marginBottom: isNonMobile == false && -10,
                      }}
                    >
                      <FormControl style={{ marginBottom: 21, marginTop: 6 }}>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          row={isNonMobile ? true : false}
                          size="medium"
                          value={radioValue}
                          onChange={handleChange}
                        >
                          <Typography
                            style={{
                              textAlign: "center",
                              marginTop: 10,
                              marginRight: 10,
                            }}
                          >
                            Audition Type :
                          </Typography>
                          <FormControlLabel
                            value={1}
                            control={<Radio tabIndex={3} />}
                            label="On Site"
                            size="medium"
                          />
                          <FormControlLabel
                            value={2}
                            control={<Radio tabIndex={4} />}
                            label="Online"
                            size="medium"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4} md={4} style={{ marginTop: -20 }}>
                      <TextField
                        label="Title*"
                        size="medium"
                        value={title}
                        inputProps={{ tabIndex: 5 }}
                        autoComplete="off"
                        onChange={(event) => setTitle(event.target.value)}
                        fullWidth
                        validators={["required"]}
                        errorMessages={["Title is required"]}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} md={4} style={{ marginTop: -20 }}>
                      <Stack spacing={2} direction="row">
                        <TextField
                          label="From Age*"
                          size="medium"
                          value={fromAge}
                          maxLength={5}
                          inputProps={{ tabIndex: 6 }}
                          onChange={(event) => {
                            const test = NumberValidate(event.target.value);
                            if (event.target.value.length <= 3) {
                              if (test || event.target.value == "") {
                                setAgeFrom(event.target.value);
                              }
                            }
                          }}
                          validators={["required"]}
                          autoComplete="off"
                          errorMessages={["From Age is required"]}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <p style={{ paddingTop: 15 }}>To</p>
                        <TextField
                          label="To Age*"
                          size="medium"
                          value={toAge}
                          inputProps={{ tabIndex: 7 }}
                          autoComplete="off"
                          onChange={(event) => {
                            const test = NumberValidate(event.target.value);
                            if (event.target.value.length <= 3) {
                              if (test || event.target.value == "") {
                                setToAge(event.target.value);
                              }
                            }
                          }}
                          validators={["required"]}
                          errorMessages={["To Age is required"]}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} md={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        options={
                          userFromSession.organizationId === 4
                            ? yrfGender
                            : gender
                        }
                        size="medium"
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) =>
                          option.value == value.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            inputProps={{ ...params.inputProps, tabIndex: 8 }}
                            label="Select Gender*"
                            value={userGenderValue}
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                            validators={["required"]}
                            errorMessages={["Gender is required"]}
                          />
                        )}
                        value={userGenderValue}
                        onChange={(_, newValue) => {
                          setUserGenderValue(newValue);
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} md={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        size="medium"
                        id="tags-outlined-countries"
                        options={allCountries}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) =>
                          option.value == value.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 9 }}
                            variant="outlined"
                            label="Select Country"
                            fullWidth
                            value={userCountryValue}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={userCountryValue}
                        onChange={(_, newValue) => {
                          if (newValue.length == 0) {
                            setUserCountryValue(newValue);
                            setStates([]);
                            setCities([]);
                            setUserStateValue([]);
                            setUserCityValue([]);
                          } else {
                            onChangeCountry(newValue);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} md={4} lg={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        size="medium"
                        id="tags-outlined"
                        options={States}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 10 }}
                            variant="outlined"
                            label="Select State"
                            fullWidth
                            value={userStateValue}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={userStateValue}
                        onChange={(_, newValue) => {
                          setUserStateValue(newValue);
                          if (newValue.length == 0) {
                            setCities([]);
                            setUserCityValue([]);
                          } else {
                            let cityFilter = allStatesCity.filter(
                              (el) =>
                                el.stateId ==
                                newValue[newValue.length - 1].value,
                            );
                            let temp = cityFilter.map((el) => ({
                              label: el.city,
                              value: el.cityId,
                              stateId: el.stateId,
                            }));
                            if (newValue.length == 1) {
                              setCities(temp);
                            } else {
                              const temp2 = cities.concat(temp);
                              setCities(temp2);
                            }
                            // }
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} md={4} lg={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        size="medium"
                        id="tags-outlined"
                        options={
                          userStateValue.length == 0 ? allCities : cities
                        }
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.label}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 11 }}
                            variant="outlined"
                            label="Select City"
                            value={UserCityValue}
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={UserCityValue}
                        onChange={(_, newValue) => {
                          setUserCityValue(newValue);
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} md={4} lg={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        id="tags-outlined"
                        size="medium"
                        options={languagesList}
                        getOptionLabel={(option) => option.languageName}
                        isOptionEqualToValue={(option, value) =>
                          option.languageId == value.languageId
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 12 }}
                            variant="outlined"
                            label="Select Language"
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={UserLanguageValue}
                        onChange={(_, newValue) => {
                          setUserLanguageValue(newValue);
                        }}
                      />
                      <Stack
                        spacing={2}
                        direction="row"
                        style={{ marginTop: 5 }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Publish On*"
                            size="medium"
                            value={publishOn}
                            onChange={(newValue) => {
                              if (newValue) {
                                if (newValue.$d == "Invalid Date") {
                                  setvalidTill(null);
                                }
                                setPublishOn(newValue.$d);
                              }
                            }}
                            open={openPublishOn}
                            onOpen={() => setOpenPublishOn(true)}
                            onClose={() => setOpenPublishOn(false)}
                            disablePast
                            inputFormat="DD-MM-YYYY"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="medium"
                                inputProps={{
                                  ...params.inputProps,
                                  tabIndex: 13,
                                  readOnly: true,
                                }}
                                value={publishOn}
                                autoComplete="off"
                                onClick={() =>
                                  handleTextFieldClick("publishOn")
                                }
                                validators={["required"]}
                                errorMessages={["Publish On is required"]}
                                onKeyPress={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                              />
                            )}
                          />
                          <DatePicker
                            label={"Valid Till*"}
                            value={validTill}
                            size="medium"
                            minDate={publishOn}
                            maxDate={endDate}
                            open={openValidTill}
                            onOpen={() => setOpenValidTill(true)}
                            onClose={() => setOpenValidTill(false)}
                            onChange={(newValue) => {
                              if (newValue) {
                                setvalidTill(newValue.$d);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                inputProps={{
                                  ...params.inputProps,
                                  tabIndex: 14,
                                  readOnly: true,
                                }}
                                size="medium"
                                value={validTill}
                                onClick={() =>
                                  handleTextFieldClick("validTill")
                                }
                                autoComplete="off"
                                validators={["required"]}
                                errorMessages={["Valid Till is required"]}
                                onKeyPress={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                              />
                            )}
                            inputFormat="DD-MM-YYYY"
                            disabled={
                              publishOn == "Invalid Date" ? true : false
                            }
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>

                    <Grid
                      item
                      xs={4}
                      sm={2}
                      md={4}
                      lg={4}
                      style={{ marginTop: -20, marginBottom: 20 }}
                    >
                      {radioValue === "2" ? (
                        <TextField
                          style={{
                            display: "block",
                            height: 25,
                            borderColor: "grey",
                            borderWidth: 1,
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            document.getElementById("getFile").click();
                          }}
                          placeholder="Upload Script File*"
                          disabled
                          fullWidth={true}
                          value={
                            uploadSelectedFile.length > 0
                              ? uploadSelectedFile.length + " Files selected"
                              : null
                          }
                          validators={["required"]}
                          errorMessages={["Select a file"]}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{ cursor: "pointer" }}
                              >
                                {radioValue === 2
                                  ? "Choose file*"
                                  : "Choose file"}
                              </InputAdornment>
                            ),
                          }}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      ) : (
                        <TextField
                          style={{
                            display: "block",
                            height: 25,
                            borderColor: "grey",
                            borderWidth: 1,
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            document.getElementById("getFile").click();
                          }}
                          placeholder="Upload Script File"
                          disabled
                          fullWidth={true}
                          errorMessages={[""]}
                          value={
                            uploadSelectedFile.length > 0
                              ? uploadSelectedFile.length + " Files selected"
                              : null
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{ cursor: "pointer" }}
                              >
                                {radioValue === 2
                                  ? "Choose file*"
                                  : "Choose file"}
                              </InputAdornment>
                            ),
                          }}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      )}

                      <TextField
                        ref={fileUploadRef}
                        size="medium"
                        id="getFile"
                        name="avatar"
                        value={uploadFile}
                        type={"file"}
                        inputProps={{
                          multiple: true,
                          accept:
                            // "application/pdf,.docx,.doc,application/msword",
                            "application/pdf,application/msword",
                        }}
                        onChange={fileChangedHandler}
                        fullWidth
                        style={{ display: "none" }}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />

                      <TextField
                        style={{
                          display: "block",
                          height: 25,
                          borderColor: "grey",
                          borderWidth: 1,
                          fontWeight: "bold",
                          paddingTop: 35,
                        }}
                        onClick={() => {
                          document.getElementById("getFileVideo").click();
                        }}
                        placeholder="Upload Script Video File"
                        disabled
                        fullWidth={true}
                        value={
                          uploadSelectedVideoFile.length > 0
                            ? uploadSelectedVideoFile.length +
                              " Videos selected"
                            : null
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              style={{ cursor: "pointer" }}
                            >
                              Choose file
                            </InputAdornment>
                          ),
                        }}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />

                      <TextField
                        ref={videoUploadRef}
                        size="medium"
                        id="getFileVideo"
                        name="avatar"
                        value={uploadVideoFile}
                        type={"file"}
                        inputProps={{ multiple: true, accept: "video/*" }}
                        onChange={fileChangedHandlerVideo}
                        fullWidth
                        style={{ display: "none" }}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      md={4}
                      lg={4}
                      style={{ marginTop: isNonMobile ? -20 : 20 }}
                    >
                      <TextField
                        label="Description*"
                        value={description}
                        inputProps={{ tabIndex: 16 }}
                        size="medium"
                        onChange={(event) => {
                          if (event.target.value.length <= 3000) {
                            setDescription(event.target.value);
                          }
                        }}
                        autoComplete="off"
                        maxLength={5}
                        multiline
                        minRows={4.5}
                        maxRows={8}
                        validators={["required"]}
                        errorMessages={["Description is required"]}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />
                      <div
                        style={{
                          marginTop: -10,
                          display: "flex",
                          flexDirection: "row-reverse",
                        }}
                      >
                        <Typography style={{ color: "#9A9A9A" }}>
                          {description === "" ? 0 : description.length}/3000
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid style={{ paddingTop: 16 }}>
                    <Button
                      disabled={onApiLoading}
                      variant="contained"
                      type="submit"
                      size="medium"
                      tabIndex={15}
                      sx={{
                        ":hover": { backgroundColor: "#ea232a" },
                        backgroundColor: "#B93B3E",
                      }}
                    >
                      {onApiLoading === true ? (
                        <CircularProgress
                          size={20}
                          color="inherit"
                          sx={{ alignItems: "center" }}
                        />
                      ) : (
                        <>{use == "create" ? "Submit" : "Update"}</>
                      )}
                    </Button>
                  </Grid>
                </ValidatorForm>
              </SimpleCard>
            </>
          ) : (
            <>
              {APILoading ? (
                <Loading />
              ) : (
                <ValidatorForm
                  onSubmit={() =>
                    onClickSubmitPost(use == "create" ? "Insert" : "Update")
                  }
                  onError={() => null}
                >
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                  >
                    <Grid item xs={4}>
                      <Autocomplete
                        options={projectList}
                        size="medium"
                        getOptionLabel={(option) => option.projectName}
                        disabled={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Select Project*"
                            value={projectSelected}
                            fullWidth
                            validators={["required"]}
                            errorMessages={["Project is required"]}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={projectSelected}
                        onChange={(_, newValue) => {
                          setProjectSelected(newValue);
                          setCharacterData(newValue.characterData);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ marginTop: isNonMobile == false && -20 }}
                    >
                      <Autocomplete
                        options={characterData}
                        size="medium"
                        disabled={true}
                        getOptionLabel={(option) => option.characterName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Select Character*"
                            value={charSelected}
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={charSelected}
                        onChange={(_, newValue) => {
                          setCharSelected(newValue);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{
                        marginTop: isNonMobile == false && -30,
                        marginBottom: isNonMobile == false && -10,
                      }}
                    >
                      <FormControl style={{ marginBottom: 21, marginTop: 6 }}>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          row={isNonMobile ? true : false}
                          size="small"
                          value={radioValue}
                          onChange={handleChange}
                        >
                          <Typography
                            style={{
                              textAlign: "center",
                              marginTop: 10,
                              marginRight: 5,
                              fontSize: 13,
                            }}
                          >
                            Audition Type :
                          </Typography>
                          <FormControlLabel
                            value={1}
                            control={<Radio tabIndex={1} />}
                            label="On Site"
                            size="small"
                            sx={{ fontSize: 10, marginRight: 1 }}
                          />
                          <FormControlLabel
                            value={2}
                            control={<Radio tabIndex={2} />}
                            label="Online"
                            size="small"
                            sx={{ fontSize: 10 }}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={4} style={{ marginTop: -20 }}>
                      <TextField
                        label="Title*"
                        value={title}
                        onChange={(event) => setTitle(event.target.value)}
                        inputProps={{ tabIndex: 3 }}
                        fullWidth
                        validators={["required"]}
                        errorMessages={["Title is required"]}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} style={{ marginTop: -20 }}>
                      <Stack spacing={2} direction="row">
                        <TextField
                          label="From Age*"
                          value={fromAge}
                          inputProps={{ tabIndex: 4 }}
                          onChange={(event) => {
                            const test = NumberValidate(event.target.value);
                            if (event.target.value.length <= 3) {
                              if (test || event.target.value == "") {
                                setAgeFrom(event.target.value);
                              }
                            }
                          }}
                          multiline
                          validators={["required"]}
                          autoComplete="off"
                          errorMessages={["From Age is required"]}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <p style={{ paddingTop: 15 }}>To</p>
                        <TextField
                          label="To Age*"
                          value={toAge}
                          inputProps={{ tabIndex: 5 }}
                          autoComplete="off"
                          onChange={(event) => {
                            const test = NumberValidate(event.target.value);
                            if (event.target.value.length <= 3) {
                              if (test || event.target.value == "") {
                                setToAge(event.target.value);
                              }
                            }
                          }}
                          validators={["required"]}
                          errorMessages={["To Age is required"]}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        options={
                          userFromSession.organizationId === 4
                            ? yrfGender
                            : gender
                        }
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) =>
                          option.value == value.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 6 }}
                            variant="outlined"
                            label="Select Gender*"
                            value={userGenderValue}
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={userGenderValue}
                        onChange={(_, newValue) => {
                          setUserGenderValue(newValue);
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} md={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        size="medium"
                        id="tags-outlined-countries"
                        options={allCountries}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) =>
                          option.value == value.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 9 }}
                            variant="outlined"
                            label="Select Country"
                            fullWidth
                            value={userCountryValue}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={userCountryValue}
                        onChange={(_, newValue) => {
                          if (newValue.length == 0) {
                            setUserCountryValue(newValue);
                            setStates([]);
                            setCities([]);
                            setUserStateValue([]);
                            setUserCityValue([]);
                          } else {
                            onChangeCountry(newValue);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={States}
                        isOptionEqualToValue={(option, value) =>
                          option.value == value.value
                        }
                        autoSelect={true}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.label}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 7 }}
                            variant="outlined"
                            label="Select State"
                            fullWidth
                            value={userStateValue}
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={userStateValue}
                        onChange={(_, newValue) => {
                          setUserStateValue(newValue);
                          if (newValue.length == 0) {
                            setCities([]);
                            setUserCityValue([]);
                          } else {
                            let cityFilter = allStatesCity.filter(
                              (el) =>
                                el.stateId ==
                                newValue[newValue.length - 1].value,
                            );
                            let temp = cityFilter.map((el) => ({
                              label: el.city,
                              value: el.cityId,
                              stateId: el.stateId,
                            }));
                            if (newValue.length == 1) {
                              setCities(temp);
                            } else {
                              setCities([...cities, ...temp]);
                            }
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={
                          userStateValue.length == 0 ? allCities : cities
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.value == value.value
                        }
                        renderOption={(props, option) => (
                          <li {...props} key={option.value}>
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 8 }}
                            variant="outlined"
                            label="Select City"
                            value={UserCityValue}
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={UserCityValue}
                        onChange={(_, newValue) => {
                          setUserCityValue(newValue);
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} style={{ marginTop: -20 }}>
                      <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={languagesList}
                        getOptionLabel={(option) => option.languageName}
                        isOptionEqualToValue={(option, value) =>
                          option.languageId == value.languageId
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputProps={{ ...params.inputProps, tabIndex: 9 }}
                            variant="outlined"
                            label="Select Language"
                            fullWidth
                            onKeyPress={(e) => {
                              e.key === "Enter" && e.preventDefault();
                            }}
                          />
                        )}
                        value={UserLanguageValue}
                        onChange={(_, newValue) => {
                          setUserLanguageValue(newValue);
                        }}
                      />
                      <Stack spacing={2} direction="row">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Publish On*"
                            value={publishOn}
                            minDate={publishOn}
                            onChange={(newValue) => {
                              if (newValue) {
                                if (newValue.$d == "Invalid Date") {
                                  setvalidTill(null);
                                }
                                if (
                                  moment(newValue.$d).format("YYYY-MM-DD") >
                                  validTill
                                ) {
                                  setvalidTill(null);
                                }
                                setPublishOn(newValue.$d);
                              }
                            }}
                            open={openPublishOn}
                            onOpen={() => setOpenPublishOn(true)}
                            onClose={() => setOpenPublishOn(false)}
                            inputFormat="DD-MM-YYYY"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                value={publishOn}
                                inputProps={{
                                  ...params.inputProps,
                                  tabIndex: 11,
                                }}
                                validators={["required"]}
                                autoComplete="off"
                                onClick={() =>
                                  handleTextFieldClick("publishOn")
                                }
                                errorMessages={["Publish On is required"]}
                                onKeyPress={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                              />
                            )}
                          />
                          <DatePicker
                            label={"Valid Till*"}
                            value={validTill}
                            onChange={(newValue) => {
                              if (newValue) {
                                setvalidTill(newValue.$d);
                              }
                            }}
                            open={openValidTill}
                            onOpen={() => setOpenValidTill(true)}
                            onClose={() => setOpenValidTill(false)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                inputProps={{
                                  ...params.inputProps,
                                  tabIndex: 12,
                                  readOnly: true,
                                }}
                                value={validTill}
                                onClick={() =>
                                  handleTextFieldClick("validTill")
                                }
                                validators={["required"]}
                                autoComplete="off"
                                errorMessages={["Valid Till is required"]}
                                onKeyPress={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                              />
                            )}
                            minDate={publishOn}
                            inputFormat="DD-MM-YYYY"
                            disabled={
                              publishOn == "Invalid Date" ? true : false
                            }
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>

                    <Grid
                      item
                      xs={4}
                      sm={2}
                      md={4}
                      style={{ marginTop: -20, marginBottom: 20 }}
                    >
                      {radioValue === "2" ? (
                        <TextField
                          style={{
                            display: "block",
                            height: 25,
                            borderColor: "grey",
                            borderWidth: 1,
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            document.getElementById("getFile").click();
                          }}
                          placeholder="Upload Script File*"
                          disabled
                          fullWidth={true}
                          value={
                            uploadSelectedFile.length > 0
                              ? uploadSelectedFile.length + " Files selected"
                              : null
                          }
                          validators={["required"]}
                          errorMessages={["Select a file"]}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{ cursor: "pointer" }}
                              >
                                {radioValue === 2
                                  ? "Choose file*"
                                  : "Choose file"}
                              </InputAdornment>
                            ),
                          }}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      ) : (
                        <TextField
                          style={{
                            display: "block",
                            height: 25,
                            borderColor: "grey",
                            borderWidth: 1,
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            document.getElementById("getFile").click();
                          }}
                          placeholder="Upload Script File"
                          disabled
                          fullWidth={true}
                          value={
                            uploadSelectedFile.length > 0
                              ? uploadSelectedFile.length + " Files selected"
                              : null
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{ cursor: "pointer" }}
                              >
                                {radioValue === 2
                                  ? "Choose file*"
                                  : "Choose file"}
                              </InputAdornment>
                            ),
                          }}
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                      )}

                      <TextField
                        ref={fileUploadRef}
                        size="medium"
                        id="getFile"
                        name="avatar"
                        value={uploadFile}
                        type={"file"}
                        inputProps={{
                          multiple: true,
                          accept:
                            // "application/pdf,.docx,.doc,application/msword",
                            "application/pdf,.docx,.doc,application/msword",
                        }}
                        onChange={fileChangedHandler}
                        fullWidth
                        style={{ display: "none" }}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />

                      <TextField
                        style={{
                          display: "block",
                          height: 25,
                          borderColor: "grey",
                          borderWidth: 1,
                          fontWeight: "bold",
                          paddingTop: 35,
                        }}
                        onClick={() => {
                          document.getElementById("getFileVideo").click();
                        }}
                        placeholder="Upload Script Video File"
                        disabled
                        fullWidth={true}
                        value={
                          uploadSelectedVideoFile.length > 0
                            ? uploadSelectedVideoFile.length +
                              " Videos selected"
                            : null
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              style={{ cursor: "pointer" }}
                            >
                              Choose file
                            </InputAdornment>
                          ),
                        }}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />

                      <TextField
                        ref={videoUploadRef}
                        size="medium"
                        id="getFileVideo"
                        name="avatar"
                        value={uploadVideoFile}
                        type={"file"}
                        inputProps={{ multiple: true, accept: "video/*" }}
                        onChange={fileChangedHandlerVideo}
                        fullWidth
                        style={{ display: "none" }}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ marginTop: isNonMobile ? -20 : 20 }}
                    >
                      <TextField
                        label="Description*"
                        value={description}
                        onChange={(event) => {
                          if (event.target.value.length <= 3000) {
                            setDescription(event.target.value);
                          }
                        }}
                        inputProps={{ tabIndex: 10 }}
                        autoComplete="off"
                        multiline
                        minRows={4.5}
                        maxRows={8}
                        validators={["required"]}
                        errorMessages={["Description is required"]}
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                      />
                      <div
                        style={{
                          marginTop: -10,
                          display: "flex",
                          flexDirection: "row-reverse",
                        }}
                      >
                        <Typography style={{ color: "#9A9A9A" }}>
                          {description === "" ? 0 : description.length}/3000
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <div
                    style={{
                      paddingTop: 16,
                      flexDirection: "row-reverse",
                      display: "flex",
                    }}
                  >
                    <Button
                      sx={{
                        ":hover": { backgroundColor: "#ea232a" },
                        backgroundColor: "#B93B3E",
                      }}
                      disabled={onApiLoading}
                      variant="contained"
                      type="submit"
                      size="large"
                      tabIndex={13}
                    >
                      {onApiLoading === true ? (
                        <CircularProgress
                          size={20}
                          color="inherit"
                          sx={{ alignItems: "center" }}
                        />
                      ) : (
                        <>{use == "create" ? "Submit" : "Update"}</>
                      )}
                    </Button>
                  </div>
                </ValidatorForm>
              )}
            </>
          )}
        </Stack>

        {snackOpen && (
          <CustomSnackBar
            openSnackBar={snackOpen}
            handleCloseSnackBar={handleCloseSnackBar}
            severity={
              snackBarMessage == "Server Error" ||
              "Please upload a file smaller than 10 MB"
                ? "error"
                : "Enter Valid Age"
                  ? "warning"
                  : "Audition updated successfully"
                    ? "Success"
                    : "success"
            }
            message={snackBarMessage}
          />
        )}
        {errorPopUp && (
          <ServerErrorModal
            popUpFor={errorMsg}
            openAlert={errorPopUp}
            handleCloseAlert={handleServerError}
          />
        )}
      </div>
    </DocumentTitle>
  );
};

export default CreateUpdatePost;
